import { memo } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../store";
import {
  ComplexFormSchemaComponents,
  SimpleFormSchemaComponents,
  isComplexComponent,
} from "../types";

import { ComplexComponentFactory } from "./ComplexComponentsFactory";
import { SimpleComponentFactory } from "./SimpleComponentsFactory";

type ComponentsFactoryProps = {
  readonly component: ComplexFormSchemaComponents | SimpleFormSchemaComponents;
};

export const ComponentsFactory = memo<ComponentsFactoryProps>(
  ({ component }) => {
    const { isVisible: visibleSelector } = component;

    const isVisible = useSelector((state: RootState) => {
      if (typeof visibleSelector === "boolean" || !visibleSelector) {
        return true;
      }

      return visibleSelector(state);
    });

    if (!isVisible) {
      return null;
    }

    if (isComplexComponent(component)) {
      return (
        <ComplexComponentFactory key={component.id} component={component} />
      );
    }

    return <SimpleComponentFactory key={component.id} component={component} />;
  }
);
